// extracted by mini-css-extract-plugin
export default {"channelTabWrapper":"BH6Rn"};